import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import SingleWirePage, { getDefaultData } from "components/pages/SingleWirePage";
import Classes, { Payee } from "model";

export default function CaptureSingleWirePayeeSelected(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["wire", "payee"], Payee.initByID(0)).submit();

  return (
    <SingleWirePage data={data} />
  )
}
